<nav class="sidemenu">
    <ul>
        <li class="itemLogo">
            <img src = "../../../assets/logo.png" width="40px">
            <span class="logo">Agenda de contatos</span>
        </li>
        <li routerLink="/home"><mat-icon>home</mat-icon>Início</li>
        <li routerLink="/contacts"><mat-icon>contacts</mat-icon>Contatos</li>
        <a href="" (click)="logout()" class="logout"><li><mat-icon>logout</mat-icon>Sair</li></a>
    </ul>
</nav>
